import { useState } from 'react';

import { FooterContext, type FooterConfig } from './FooterContext';

interface Props {
	children: React.ReactNode;
}

export const FooterContextProvider = ({ children }: Props) => {
	const [config, setConfig] = useState<FooterConfig>();

	return (
		<FooterContext.Provider value={{ config, setConfig }}>{children}</FooterContext.Provider>
	);
};
